(function () {
  var ATTRIBUTION_LINK_SELECTOR = '[data-prairie-hubspot-attribution-link]';
  var STORAGE_KEY = 'prairie_for_business_attribution';
  var AD_PARAM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid',
    'gclid',
  ];
  var LP_FIELD_KEYS = [
    'biz_lp_landing_url',
    'biz_lp_referrer',
    'biz_lp_first_landing_at',
  ];
  var ALL_FIELD_KEYS = AD_PARAM_KEYS.concat(LP_FIELD_KEYS);

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function getIsoDate() {
    return new Date().toISOString().slice(0, 10);
  }

  function getStoredAttribution() {
    try {
      var rawValue = window.sessionStorage.getItem(STORAGE_KEY);
      return rawValue ? JSON.parse(rawValue) : {};
    } catch (error) {
      return {};
    }
  }

  function setStoredAttribution(value) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (error) {
      // The external form still opens without sessionStorage.
    }
  }

  function hasAnyAdParam(searchParams) {
    return AD_PARAM_KEYS.some(function (key) {
      return searchParams.has(key) && searchParams.get(key);
    });
  }

  function buildAttribution() {
    var searchParams = new URLSearchParams(window.location.search);
    var storedValue = getStoredAttribution();
    var hasNewAdParam = hasAnyAdParam(searchParams);
    var shouldRefreshLanding = Object.keys(storedValue).length === 0 || hasNewAdParam;
    var nextValue = Object.assign({}, storedValue);

    if (hasNewAdParam) {
      AD_PARAM_KEYS.forEach(function (key) {
        delete nextValue[key];
      });
    }

    AD_PARAM_KEYS.forEach(function (key) {
      var value = searchParams.get(key);

      if (value) {
        nextValue[key] = value;
      }
    });

    if (shouldRefreshLanding) {
      nextValue.biz_lp_landing_url = window.location.href;
      nextValue.biz_lp_referrer = document.referrer || '';
      nextValue.biz_lp_first_landing_at = getIsoDate();
    }

    setStoredAttribution(nextValue);

    return nextValue;
  }

  function buildAttributedUrl(baseUrl, attribution) {
    var url = new URL(baseUrl, window.location.href);

    ALL_FIELD_KEYS.forEach(function (key) {
      var value = attribution[key];

      if (value) {
        url.searchParams.set(key, value);
      }
    });

    return url.toString();
  }

  function enhanceAttributionLinks(attribution) {
    var links = document.querySelectorAll(ATTRIBUTION_LINK_SELECTOR);

    links.forEach(function (link) {
      var baseHref = link.getAttribute('data-prairie-hubspot-attribution-link') || link.href;

      if (!baseHref) {
        return;
      }

      var updateHref = function () {
        link.href = buildAttributedUrl(baseHref, attribution);
      };

      updateHref();
    });
  }

  onReady(function () {
    enhanceAttributionLinks(buildAttribution());
  });
})();
